import { SDrawerOrModal, SEditor, SSkuCard } from 'shj-components'
import { SearchBar } from './SearchBar'
import { useEffect, useRef, useState } from 'react'
import styles from '../index.module.less'
import { useDebounceEffect, useSetState } from 'ahooks'
import { useParams } from 'react-router-dom'
import _, { isArray, isEmpty, uniqueId } from 'lodash'
import { Button, Pagination, Spin, Table, Tabs, Tooltip } from 'antd'
import {
  subtractSearch,
  queryActivityProduct,
  projectSearchPage,
  generalSearchPage,
  additionSearchPage,
  upDownSearchPage,
  listProductSkuRelationSpuFormat,
  additionSearchForGeneral,
  additionSearchForSpecialAdd,
} from '@/services/order'
import { productManagementDetail, productSkuDetail } from '@/services/product.ts'
import ProductDetailDrawer from '@/components/ProductDetailDrawer'
import ModifyStandard from '../../components/modifyStandard'
import dayjs from 'dayjs'
import KitDetailDialogV3 from '../../components/KitDetailDialogV3'

type IProps = {
  setSelectMaterialObj: (array: any) => void
  selectMaterialObj: any
  setCurrentSearchParams: (code: any) => void // 设置当前参数
  deleteMaterialObj: any // 删除的物料
}
export const LeftSelectArea = (props: IProps) => {
  const { setSelectMaterialObj, setCurrentSearchParams, deleteMaterialObj } = props
  const [searchParams, setSearchParams] = useState<any>({}) // 搜索参数
  const [tableLoading, setTableLoading] = useState(false)
  const params = useParams()
  const budgetId = params.budgetId //报价id
  const type = params.type //类型
  const refItemId = params.refItemId || ''
  const [data, setData] = useState<any>([]) // 表格显示数据
  const [pagination, setPagination] = useState({
    current: 1,
    pageSize: 10,
    total: 0,
  })
  const [modifyLoading, setModifyLoading] = useState<boolean>(false) // 修改规格loading
  const [modifyStandardOpen, setModifyStandardOpen] = useState(false) // 修改规格
  const [currentModifyStandardArray, setCurrentModifyStandardArray] = useState<any>([]) // 当前修改规格数组
  const [skuList, setSkuList] = useState<any>([]) // 当前产品的sku map信息
  const [record, setRecord] = useState<any>({}) // 当前产品信息
  // 套件选择
  const [kitSku, setKitSku] = useState<any>({})
  const [kitSpu, setKitSpu] = useState<any>({})
  const [activityInfo, setActivityInfo] = useState<any>({})
  const [openKitDialog, setOpenKitDialog] = useState(false)
  const [combinationInfoList, setCombinationInfoList] = useState<any[]>([])
  const tagsMap = {
    prodcateName: 'Order-tagClass',
  }
  const [columns, setColumns] = useState<any>([
    {
      title: '产品',
      dataIndex: 'product',
      width: 250,
      render: (text, record) => {
        return (
          <SSkuCard
            width={'100%'}
            url={record.productSpuPrimaryImage}
            urlList={record?.productSpu?.imageUrls}
            desc={`SPU: ${record.productSpuId}`}
            operation={() => {
              return <div></div>
            }}
            title={
              <a
                style={{ fontSize: '12px', fontWeight: '400' }}
                onClick={() => onOpenProductDetail(record.productSpuId)}
              >
                {showProdCateTagRender(record?.productSpu?.prodCateName)}
                <Tooltip
                  title={
                    <div>
                      <div>{record?.productSpu?.prodCateName}</div>
                      <div>{record.productSpuName}</div>
                    </div>
                  }
                >
                  {record.productSpuName}
                </Tooltip>
              </a>
            }
          ></SSkuCard>
        )
      },
    },
    {
      title: '单位',
      dataIndex: 'productSpuUnitName',
      width: 80,
      ellipsis: {
        showTitle: true,
      },
    },
    {
      title: '单价',
      dataIndex: 'priceRange',
      width: 100,
    },
    {
      title: '预计下架日期',
      dataIndex: 'outOfStockTime',
      width: 120,
      render: (text, record) => {
        return text ? dayjs(text).format('YYYY-MM-DD') : ''
      },
    },
    {
      title: '操作',
      dataIndex: '#',
      width: 80,
      render: (text, record) => {
        return <Button onClick={() => clickToSelect(record)}>选择</Button>
      },
      fixed: 'right',
    },
  ])
  const tableRef = useRef<any>()
  const [state, setState] = useSetState<any>({
    open: false,
    loading: false,
    descType: [],
    data: {},
  })

  const dataRef = useRef()
  const queryRef = useRef<any>()
  dataRef.current = data // 解决闭包问题
  queryRef.current = searchParams
  // 获取列表明细
  const fetchList = async (pageInfo?) => {
    const query = { ...searchParams }
    query.current = pageInfo ? pageInfo?.current : 1
    query.pageSize = pageInfo ? pageInfo?.pageSize : 10
    query.quoteBudgetId = budgetId // 报价id 881504385413152768
    // 品牌搜索处理：
    query.brandId = query.brandId === '不限' ? '' : query.brandId
    query.activityId = query.activityId === '不限' ? '' : query.activityId
    query.productSourceTypeBus =
      query.productSourceTypeBus === 'all' ? null : query.productSourceTypeBus
    query.type = type
    console.log(query, 'query')

    let api // 根据选材类型获取不同的接口
    let newColumns: any[] = columns
    switch (type) {
      case 'GENERAL':
        delete query.addType
        query.searchSkusPrice = true // 查询价格区间
        if (!query.generalId) {
          setTableLoading(false)
          return
        }
        api = generalSearchPage
        break
      case 'ADD':
        // 增项查询
        query.generalId = ''
        query.addType = query.addType ? query.addType : 'PRODUCT' //初次请求默认为产品
        // api = additionSearchPage
        if (query.addType === 'PRODUCT') {
          query.searchSkusPrice = true // 查询价格区间
          api = additionSearchPage
          newColumns = [
            {
              title: '产品',
              dataIndex: 'product',
              width: 250,
              render: (text, record) => {
                return (
                  <SSkuCard
                    width={'100%'}
                    url={record.productSpuPrimaryImage}
                    urlList={record?.productSpu?.imageUrls}
                    desc={'SPU: ' + record.productSpuId}
                    operation={() => {
                      return <div></div>
                    }}
                    title={
                      <a
                        style={{ fontSize: '12px', fontWeight: '400' }}
                        onClick={() => onOpenProductDetail(record.productSpuId)}
                      >
                        {showProdCateTagRender(record?.productSpu?.prodCateName)}
                        <Tooltip
                          title={
                            <div>
                              <div>{record?.productSpu?.prodCateName}</div>
                              <div>{record.productSpuName}</div>
                            </div>
                          }
                        >
                          {record.productSpuName}
                        </Tooltip>
                      </a>
                    }
                  ></SSkuCard>
                )
              },
            },
            {
              title: '单位',
              dataIndex: 'productSpuUnitName',
              width: 80,
              ellipsis: {
                showTitle: true,
              },
            },
            {
              title: '单价',
              dataIndex: 'priceRange',
              width: 100,
            },
            {
              title: '预计下架日期',
              dataIndex: 'outOfStockTime',
              width: 120,
              render: (text, record) => {
                return text ? dayjs(text).format('YYYY-MM-DD') : ''
              },
            },
            {
              title: '操作',
              dataIndex: '#',
              width: 80,
              render: (text, record) => {
                return <Button onClick={() => clickToSelect(record)}>选择</Button>
              },
              fixed: 'right',
            },
          ]
        } else if (query.addType === 'GENERAL') {
          api = additionSearchForSpecialAdd
          newColumns = [
            {
              title: '通项',
              dataIndex: 'referenceName',
              width: 250,
            },
            {
              title: '单价',
              dataIndex: 'saleCustPrice',
              width: 100,
            },
            {
              title: '已减量',
              dataIndex: 'reducedSize',
              width: 100,
            },
            {
              title: '所在位置',
              dataIndex: 'spacePathNames',
              width: 100,
              render: (text, record) => {
                if (text && isArray(text)) {
                  return text.join('-')
                }
                return text
              },
            },
            {
              title: '操作',
              dataIndex: '#',
              width: 80,
              render: (text, record) => {
                return <Button onClick={() => clickToSelect(record)}>选择</Button>
              },
              fixed: 'right',
            },
          ]
        } else {
          api = additionSearchForSpecialAdd
          newColumns = [
            {
              title: '产品',
              dataIndex: 'product',
              width: 250,
              render: (text, record) => {
                return (
                  <SSkuCard
                    width={'100%'}
                    url={record?.productSku?.mainPicUrl}
                    urlList={record?.productSku?.imageUrls}
                    desc={record.productSkuId ? `SKU: ${record.productSkuId}` : null}
                    operation={() => {
                      return <div></div>
                    }}
                    title={
                      <a
                        style={{ fontSize: '12px', fontWeight: '400' }}
                        onClick={() => onOpenProductDetail(record.productSkuId, 'SKU')}
                      >
                        {record.referenceName}
                      </a>
                    }
                  ></SSkuCard>
                )
              },
            },
            {
              title: '单位',
              dataIndex: 'unitName',
              width: 80,
              ellipsis: {
                showTitle: true,
              },
            },
            {
              title: '单价',
              dataIndex: 'saleCustPrice',
              width: 100,
            },
            {
              title: '已减量',
              dataIndex: 'reducedSize',
              width: 100,
            },
            {
              title: '操作',
              dataIndex: '#',
              width: 80,
              render: (text, record) => {
                return <Button onClick={() => clickToSelect(record)}>选择</Button>
              },
              fixed: 'right',
            },
          ]
        }
        setColumns(newColumns)
        break
      case 'SUB':
        // 减项查询
        delete query.addType
        delete query.generalId

        api = subtractSearch
        // 当查询为通项时清除品牌查询
        if (query.subType === 'GENERAL') {
          query.brandId = ''
          newColumns = [
            {
              title: '通项名称',
              dataIndex: 'referenceName',
              width: 250,
            },
            {
              title: '单价',
              dataIndex: 'saleCustPrice',
              width: 100,
            },
            {
              title: '所在位置',
              dataIndex: 'spacePathNames',
              width: 100,
              render: (text, record) => {
                if (text && isArray(text)) {
                  return text.join('-')
                }
                return text
              },
            },
            {
              title: '可减量',
              dataIndex: 'availableQuantity',
              width: 100,
            },
            {
              title: '操作',
              dataIndex: '#',
              width: 80,
              render: (text, record) => {
                return <Button onClick={() => clickToSelect(record)}>选择</Button>
              },
              fixed: 'right',
            },
          ]
        } else {
          newColumns = [
            {
              title: '产品',
              dataIndex: 'product',
              width: 250,
              render: (text, record) => {
                return (
                  <SSkuCard
                    width={'100%'}
                    url={record?.productSku?.mainPicUrl}
                    urlList={record?.productSku?.imageUrls}
                    desc={record.productSkuId ? `SKU: ${record.productSkuId}` : null}
                    operation={() => {
                      return <div></div>
                    }}
                    title={
                      <a
                        style={{ fontSize: '12px', fontWeight: '400' }}
                        onClick={() => onOpenProductDetail(record.productSkuId)}
                      >
                        {record.referenceName}
                      </a>
                    }
                  ></SSkuCard>
                )
              },
            },
            {
              title: '单位',
              dataIndex: 'unitName',
              width: 80,
              ellipsis: {
                showTitle: true,
              },
            },
            {
              title: '单价',
              dataIndex: 'saleCustPrice',
              width: 100,
            },
            {
              title: '所在位置',
              dataIndex: 'spaceName',
              width: 100,
              render: (text, record) => {
                if (record.budgetItemList?.length > 0) {
                  return <span>{record.budgetItemList[0].showName}</span>
                }
              },
            },
            {
              title: '可减量',
              dataIndex: 'availableQuantity',
              width: 100,
            },
            {
              title: '操作',
              dataIndex: '#',
              width: 80,
              render: (text, record) => {
                return <Button onClick={() => clickToSelect(record)}>选择</Button>
              },
              fixed: 'right',
            },
          ]
        }
        setColumns(newColumns)
        break
      case 'PROJECT':
        delete query.addType
        query.searchSkusPrice = true // 查询价格区间
        query.generalId = ''
        query.quoteBudgetItemId = refItemId
        api = projectSearchPage
        break
      case 'ACTIVITY':
        // query.type = 'ACTIVITY'
        delete query.addType

        api = queryActivityProduct
        newColumns = [
          {
            title: '产品',
            dataIndex: 'product',
            width: 250,
            render: (text, record) => {
              return (
                <SSkuCard
                  width={'100%'}
                  url={record?.productSku?.mainPicUrl}
                  urlList={record?.productSku?.imageUrls}
                  desc={`SKU: ${record.productSkuId}`}
                  operation={() => {
                    return <div></div>
                  }}
                  title={
                    <a
                      style={{ fontSize: '12px', fontWeight: '400' }}
                      onClick={() => onOpenProductDetail(record.productSkuId)}
                    >
                      {record?.productSkuName}
                    </a>
                  }
                ></SSkuCard>
              )
            },
          },
          {
            title: '活动名称',
            dataIndex: ['activity', 'name'],
            width: 80,
            ellipsis: {
              showTitle: true,
            },
          },
          {
            title: '单位',
            dataIndex: 'productSpuUnitName',
            width: 80,
            ellipsis: {
              showTitle: true,
            },
          },
          {
            title: '单价',
            dataIndex: 'productSkuSalePrice',
            width: 100,
          },
          {
            title: '限制类型',
            dataIndex: 'limitTypeName',
            width: 80,
            ellipsis: {
              showTitle: true,
            },
          },
          {
            title: '剩余值',
            dataIndex: 'remainder',
            width: 80,
            ellipsis: {
              showTitle: true,
            },
            render: (text, record) => {
              if (record.limitTypeName === '金额限制') {
                return null
              } else {
                return text
              }
            },
          },
          {
            title: '预计下架日期',
            dataIndex: 'outOfStockTime',
            width: 120,
            render: (text, record) => {
              return text ? dayjs(text).format('YYYY-MM-DD') : ''
            },
          },
          {
            title: '操作',
            dataIndex: '#',
            width: 80,
            render: (text, record) => {
              return <Button onClick={() => clickToSelect(record)}>选择</Button>
            },
            fixed: 'right',
          },
        ]
        setColumns(newColumns)
        break
      case 'UP_DOWN':
        delete query.addType

        query.type = 'UP_DOWN'
        api = upDownSearchPage
        break
      default:
        break
    }
    try {
      // 处理查询参数
      query.prodType = type === 'ADD' ? query.prodType : null
      // setQueryParams({ ...query })
      let res = await api({ data: { ...query } })
      if (
        query.type === 'SUB' ||
        query.type === 'ACTIVITY' ||
        (query.type === 'ADD' && query.addType !== 'PRODUCT')
      ) {
        setData([...res])
      } else {
        res.list = res?.list.map(item => {
          return {
            ...item,
            key: uniqueId(),
          }
        })
        setData([...res?.list])
        setPagination({
          pageSize: Number(res?.pageSize || 10),
          current: Number(res?.currentPageId || 1),
          total: res?.count,
        })
      }
      setTableLoading(false)
    } catch (err) {
      setTableLoading(false)
    }
  }

  // 触发数据更新
  useDebounceEffect(
    () => {
      getList()
    },
    [searchParams],
    { wait: 500 }
  )

  const onOpenProductDetail = (productId, detailType?: string) => {
    if (!productId) return
    setState({ open: true, loading: true })
    let api =
      type === 'SUB' || type === 'ACTIVITY' || detailType === 'SKU'
        ? productSkuDetail
        : productManagementDetail
    api(productId)
      .then(res => {
        setState({ data: res })
      })
      .finally(() => setState({ loading: false }))
  }

  const getList = async () => {
    setTableLoading(true)
    // 添加防抖
    setCurrentSearchParams({ ...searchParams })
    // getColumn()
    await fetchList()
  }

  //   选择添加物料
  const clickToSelect = record => {
    // 添加物料
    // const newData: any = _.cloneDeep(dataRef.current)
    console.log(queryRef.current, 'queryRef.current')

    record.checked = true // 选到右侧默认勾选
    record.spaceChecked = [] // 造数据 空间应用
    record.generalId = type === 'ADD' || type === 'PROJECT' ? '' : queryRef.current.generalId
    record.calculate = ''
    // 区分通项和产品
    record.onlyShowTitle =
      (type === 'SUB' && record.referenceType === 'GENERAL') ||
      (type === 'ADD' && queryRef.current.addType === 'GENERAL')
    record.type = type
    record.addType = queryRef.current.addType
    setRecord(record)
    // 如果套件明细数据，过滤调不显示的数据
    if (record.productSpu?.combinationInfo?.length > 1) {
      record.productSpu.combinationInfo = record.productSpu?.combinationInfo.filter(
        item => item.allowView
      )
      // 打开套件明细弹窗
      handleKitDetail(record)
      return
    }
    console.log(record, 'old')
    // 如果有规格可以选择 提前选择
    if (type !== 'SUB' && record.productSpu?.skuSize > 1) {
      handleEditDynamicProperties(record)
    } else {
      setSelectMaterialObj(record)
    }
  }

  // 修改产品规格
  const handleEditDynamicProperties = async (record: any, index?: any) => {
    console.log(record, index)
    setModifyStandardOpen(true)
    setModifyLoading(true)
    // setCurrentIndex(index)
    let dynaOptions
    let resData
    try {
      resData = await listProductSkuRelationSpuFormat({
        data: {
          quoteBudgetId: budgetId,
          productSpuId: record.productSpuId,
          generalId:
            type === 'UP_DOWN' || type === 'GENERAL' ? queryRef?.current?.generalId || null : null,
          priceCalcType: type === 'UP_DOWN' ? 'CHANGE_LEVEL' : null,
          activityProductId: record?.activityProduct?.id || null,
        },
      })
    } catch {
      setModifyLoading(false)
    }
    setModifyLoading(false)
    dynaOptions = record.dynaOptions
    setSkuList(resData.skuList)
    resData.specificationArgList?.map((item: any) => {
      if (!isEmpty(dynaOptions)) {
        item.argValId = dynaOptions[item.argCode].valueId
        item.argValName = dynaOptions[item.argCode].valueName
      }
      item.options = item?.values.map((ol: any) => {
        return {
          ...ol,
          argValId: ol.valueId,
          argValName: ol.valueName,
        }
      })
      return item
    })
    setCurrentModifyStandardArray(resData.specificationArgList || [])
  }
  const onSubmitModifyStandard = async value => {
    let selectObj = {}
    let newRecord: any = _.cloneDeep(record)

    let newSkuObj: any = {}
    value.forEach((item: any) => {
      selectObj[item.argCode] = {
        argValId: item.argValId,
        argValName: item.argValName,
      }
    })
    // 确定sku
    skuList.forEach((item: any) => {
      let flag = true
      for (let key in selectObj) {
        if (item.argMap[key].valueId !== selectObj[key].argValId) {
          flag = false
        }
      }
      if (flag) {
        newSkuObj = item
      }
    })
    console.log(newSkuObj, '选中的sku信息')
    // 选材之后确定SKU码
    newRecord.dynaOptions = newSkuObj.argMap
    newRecord.productSkuName = newSkuObj.skuName
    newRecord.productSkuSalePrice = newSkuObj.priceInfo?.customerPrice
    newRecord.productSkuId = newSkuObj.id
    newRecord.longDesc = newSkuObj?.longDesc
    newRecord.productSpuPrimaryImage = newSkuObj?.mainPicUrl || newRecord?.productSpuPrimaryImage
    setSelectMaterialObj({ ...record, ...newRecord })
  }
  // 分页
  const onChangePage = (page, pageSize) => {
    let pageInfo = { ...pagination }
    pageInfo.current = page
    pageInfo.pageSize = pageSize
    setTableLoading(true)
    fetchList(pageInfo)
    setPagination({
      ...pagination,
      ...pageInfo,
    })
  }

  const handleKitDetail = async (record: any) => {
    setKitSku(record.productSku)
    setKitSpu(record.productSpu)
    console.log(record, 'record')
    // setCurrentIndex(index)
    // 二次点开回显
    if (type === 'ACTIVITY') {
      setActivityInfo({
        activityId: record.activity?.id,
        activityProductId: record.activityProduct?.id,
      })
    }
    if (record.packDtlList?.length) {
      setCombinationInfoList(record.packDtlList)
    } else {
      setCombinationInfoList([])
    }
    setOpenKitDialog(true)
  }
  const closeKitDialog = (value: any) => {
    setOpenKitDialog(false)
  }
  const handleLongDesc = data => {
    // 子产品有且只有一个为来源物料 工艺说明为该子产品的sku的工艺说明
    let materialList = data?.filter(
      (item: any) => item?.product?.sourceType === 'MATERIAL' && item?.checked
    )
    if (materialList.length === 1) {
      let skuInfo = materialList[0]?.skuList?.find(
        (el: any) => el.id === materialList[0]?.selectSkuId
      )
      return skuInfo?.longDesc
    } else {
      return ''
    }
  }
  const confirmInfo = (combinationInfoDetail: any, combinationPrice) => {
    console.log(combinationInfoDetail, '组合数据')
    let longDesc = ''
    if (combinationInfoDetail && combinationInfoDetail.length) {
      longDesc = handleLongDesc(combinationInfoDetail)
    }
    let newRecord: any = _.cloneDeep(record)
    newRecord.packDtlList = combinationInfoDetail
    newRecord.productSkuSalePrice =
      combinationPrice || combinationPrice === 0 ? combinationPrice : newRecord.productSkuSalePrice
    newRecord.longDesc = longDesc
    setSelectMaterialObj({ ...record, ...newRecord })
  }
  const showProdCateTagRender = (tagName: any) => {
    let strArray  = tagName?.split('/')
    let str = strArray[strArray.length-1]
    if (str) {
      return (
        <div className={tagsMap.prodcateName}>
          <Tooltip title={str}>{str}</Tooltip>
        </div>
      )
    }
  }

  return (
    <div className={styles.leftBaseBox}>
      {/* 分类 搜索区 */}
      <SearchBar
        // categoryList={categoryList}
        setSearchParams={v => setSearchParams({ ...v })}
        tableLoading={tableLoading}
      />
      {/* 物料列表 */}
      <div style={{ flex: 1, overflow: 'hidden scroll' }}>
        <Table
          sticky={{ offsetHeader: 0 }}
          columns={columns}
          dataSource={data}
          loading={tableLoading}
          pagination={false}
          ref={tableRef}
          rowKey={record => record.key}
          scroll={{ x: 'max-content' }}
        />
      </div>
      <div
        style={{
          width: '100%',
          height: '62px',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'end',
          padding: ' 0 10px',
        }}
      >
        {type !== 'SUB' &&
        type !== 'ACTIVITY' &&
        !(
          type === 'ADD' && ['GENERAL', 'REDUCED_STANDARD'].includes(queryRef?.current?.addType)
        ) ? (
          <Pagination
            total={pagination.total}
            current={pagination.current}
            pageSize={pagination.pageSize}
            showSizeChanger
            showQuickJumper
            showTotal={total => `共 ${total} 条`}
            onChange={onChangePage}
            size="small"
            showLessItems
          />
        ) : (
          <div>当前加载条数：{data.length}</div>
        )}
      </div>

      <ProductDetailDrawer previewObj={state} setPreviewObj={setState}></ProductDetailDrawer>

      {/* 修改规格 */}
      <ModifyStandard
        open={modifyStandardOpen}
        onCancel={() => {
          setModifyStandardOpen(false)
        }}
        loading={modifyLoading}
        formList={currentModifyStandardArray}
        title="选择规格"
        onSubmit={onSubmitModifyStandard}
        skuList={skuList}
        record={record}
      ></ModifyStandard>

      {/* 产品明细 */}
      {openKitDialog && (
        <KitDetailDialogV3
          kitSku={kitSku}
          setKitSku={setKitSku}
          productInfo={kitSpu}
          open={openKitDialog}
          closeDialog={closeKitDialog}
          confirmInfo={confirmInfo}
          combinationInfoList={combinationInfoList}
          activityInfo={activityInfo}
          generalId={queryRef.current.generalId}
          checkType="RightConfigArea"
        />
      )}
    </div>
  )
}
